













































import { Component, Vue } from 'vue-property-decorator';
import { IServiceUpdate } from '@/interfaces';
import { dispatchGetService, dispatchUpdateService, readOneService } from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
  },
})
export default class EditService extends Vue {
  public valid = true;
  public name: string = '';
  public proxyHost: string | null = null;
  public proxyReportHost: string | null = null;
  public proxyCallBackUrl: string | null = null;
  public passBadMessages: boolean = false;
  public ignoreUserBans: boolean = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    await dispatchGetService(this.$store, Number(this.$router.currentRoute.params.id));
    this.reset();
  }

  public reset() {
    this.$refs.observer.reset();
    if (this.service) {
      this.name = this.service.name;
      this.proxyHost = this.service.proxy_host;
      this.proxyReportHost = this.service.proxy_report_host;
      this.proxyCallBackUrl = this.service.proxy_callback_url;
      this.passBadMessages = this.service.pass_bad_messages;
      this.ignoreUserBans = this.service.ignore_user_bans;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const updatedService: IServiceUpdate = {};
      updatedService.name = this.name;
      updatedService.proxy_host = this.proxyHost;
      updatedService.proxy_report_host = this.proxyReportHost;
      updatedService.proxy_callback_url = this.proxyCallBackUrl;
      updatedService.pass_bad_messages = this.passBadMessages;
      updatedService.ignore_user_bans = this.ignoreUserBans;
      const result = await dispatchUpdateService(this.$store, { id: this.service!.id, service: updatedService });
      if (result) {
        this.$router.push('/main/admin/services');
      }
    }
  }

  get service() {
    return readOneService(this.$store)(+this.$router.currentRoute.params.id);
  }
}
